import useFetch from 'utils/hooks/useFetch'
import { ApiGetDetailPaymentReport, ApiGetPaymentInvoice } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function ReportsService() {
    const { showFail } = useModal()

    const { fetch: apiGetDetailPaymentReport } = useFetch(ApiGetDetailPaymentReport)
    const { fetch: apiGetPaymentInvoice } = useFetch(ApiGetPaymentInvoice)
 
    const fetchDetailPaymentReport = async (filterBy, periodeMonth, periodeYear, dateFrom, dateTo, bookingType, paymentType) => {
        const res = await apiGetDetailPaymentReport({
            data: {
                filterBy,
                periodeMonth,
                periodeYear,
                dateFrom, 
                dateTo, 
                bookingType,
                paymentType
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchPaymentInvoice = async (paymentId) => {
        const res = await apiGetPaymentInvoice({
            data: {
                paymentId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchDetailPaymentReport,
        fetchPaymentInvoice
    }
}